import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TableSortLabel,
  FormControlLabel,
  Checkbox,
  Tooltip,
} from "@material-ui/core";

import Pagination from "@components/pagination";
import { useStore } from "@store/store";
import { utcToTimezone } from "@utils/commonFunctions";
import { backDatedEventsListingHeader, routes, timezone, fsBackDatedStatus } from "@utils/constant";
import { TableStyle } from "./style";
import moment from "moment/moment";
import uncheckedIcon from "@assets/images/uncheck-icon.svg";
import checkedIconOrange from "@assets/images/cheked-icon-orange.svg";
import indeterminateIcon from "@assets/images/indeterminate-check-box-icon-orange.svg";
import { Link } from "react-router-dom";

function TableListing(props) {
  const classes = TableStyle();
  const [state] = useStore();

  const isSelected = (id) => props?.selectedArray?.indexOf(id) !== -1;
  const numberSelected = props.selectedArray.length;
  const data = state.customer?.backDatedEventsData;
  const totalRows = data?.rows?.filter((item) => item.status === fsBackDatedStatus.failed).length || 0;

  const getStatusClass = (status) => {
    switch (status) {
      case 'Pending Review':
        return classes.statusPending;
      case 'Processing':
        return classes.statusProcessing;
      case 'Changes Applied':
        return classes.statusApplied;
      case 'Dismissed':
        return classes.statusDismissed;
      default:
        return classes.statusFailed;
    }
  };

  const formatDateToTimezone = (date) => {
    return date ? utcToTimezone(date, timezone.SYDNEY, "DD-MM-YYYY HH:mm") + " NSW" : "N/A";
  }

  return (
    <>
      <div className={classes.TableWrapper}>
        <TableContainer component={Paper} className={classes.customTable}>
          <Table stickyHeader aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell className="check">
                  <FormControlLabel
                    className="custom-checkbox"
                    control={
                      <Checkbox
                        icon={
                          <img src={uncheckedIcon} alt="UnCheckBox" />
                        }
                        checkedIcon={
                          <img src={checkedIconOrange} alt="CheckBox" />
                        }
                        indeterminateIcon={
                          <img src={indeterminateIcon} alt="CheckBox" />
                        }
                        indeterminate={
                          numberSelected > 0 && numberSelected < totalRows
                        }
                        checked={totalRows > 0 && numberSelected === totalRows}
                        name="check"
                        onChange={(e) => props.handleMainChange(e)}
                      />
                    }
                  />
                </TableCell>
                {backDatedEventsListingHeader.map((item, index) => {
                  return (
                    <TableCell key={index} className={item.className}>
                      {item?.className === "impactedPeriod" ? (
                        <Tooltip title={item.tooltipMessage} arrow placement="top">
                          <span>{item.title}</span>
                        </Tooltip>
                      ) : (
                        <span>{item.title}</span>
                      )}
                      {item.sort && (
                        <TableSortLabel
                          direction={
                            props.orderBy === item.sortTitle ? props.order : "desc"
                          }
                          active={true}
                          onClick={(e) => props.handleSorting(e, item)}
                        />
                      )}
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.count === 0 ? (
                <TableRow className="noData">
                  <TableCell colSpan={backDatedEventsListingHeader.length + 1}>
                    <span>No Data Found</span>
                  </TableCell>
                </TableRow>
              ) : (
                data?.rows?.map((item) => (
                  <TableRow key={item.id}>
                    {
                      item.status === fsBackDatedStatus.failed ? (
                        <TableCell className="check">
                          <FormControlLabel
                            className="custom-checkbox"
                            control={
                              <Checkbox
                                icon={
                                  <img src={uncheckedIcon} alt="UnCheckBox" />
                                }
                                checkedIcon={
                                  <img src={checkedIconOrange} alt="CheckBox" />
                                }
                                checked={isSelected(item.id)}
                                onChange={() => props.handleChange(item)}
                                name="check"
                              />
                            }
                          />
                        </TableCell>
                      ) : (
                        <TableCell className="check" />
                      )}
                    <TableCell className="customer">
                      {item?.customers && item?.cities ? (
                        <Link
                          to={`${routes.customerDetail}/${item?.customers?.id}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {item?.customers?.name + " - " + item?.cities?.name}
                        </Link>
                        ) : (
                          "-"
                        )
                      }
                    </TableCell>
                    <TableCell className="impactedPeriod">
                      {item?.impactPeriodStart ? (
                        <>
                          {moment(item.impactPeriodStart).format("DD-MM-YYYY")} →
                          <br />
                          {moment(item.fuelSurcharges?.endDate ?? moment()).format("DD-MM-YYYY")}
                        </>
                      ) : (
                        "-"
                      )}
                    </TableCell>
                    <TableCell className="newRate">
                      {item.fuelSurcharges?.fuelSurcharge ? item.fuelSurcharges?.fuelSurcharge + "%" : "0"}
                    </TableCell>
                    <TableCell className="impactedJobs">
                      {item?.impactedJobsCount ?? "-"}
                    </TableCell>
                    <TableCell className="impactedDraftInvoices">
                      {item?.impactedInvoicesCount ?? "-"}
                    </TableCell>
                    <TableCell className="lastUpdate">
                      {item?.updatedAt && formatDateToTimezone(item.updatedAt)}
                    </TableCell>
                    <TableCell className="status">
                      <p className={`${classes.status} ${getStatusClass(item?.status)}`}>
                        {item?.status ?? "-"}
                      </p>
                    </TableCell>
                    <TableCell className="action">
                      {item?.status === fsBackDatedStatus.changesApplied && (
                        <span className={classes.viewLog}>
                          <Link to={`${routes.backDatedEventsLog}/${item?.id}`}>View Log</Link>
                        </span>
                      )}
                      {item?.status === fsBackDatedStatus.failed && (
                        <>
                          <span
                            className={classes.retry}
                            onClick={() => {
                              props.handleRetry(item);
                            }}
                          >
                            Retry
                          </span>
                          <span
                            className={classes.dismiss}
                            onClick={() => {
                              props.handleDismiss(item);
                            }}
                          >
                            Dismiss
                          </span>
                        </>
                      )}
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {data?.count !== 0 && (
          <div className="pagination-wrapper">
            <Pagination
              count={data?.count}
              page={props.page}
              handleChangePage={props.handleChangePage}
              rowsPerPage={props.rowsPerPage}
              handleChangeRowsPerPage={props.handleChangeRowsPerPage}
            />
          </div>
        )}
      </div>
    </>
  );
}
export default TableListing;
